module.exports = __webpack_public_path__ + "static/media/casino-nobili-villa-cavazzoli.fc931d84.svg";